import { mediaUrl } from "../lib/api";

// Neutral avatar: shows the uploaded image if present, otherwise a monogram
// of the artist's stage name. Never uses a stock photo of a real person.
export const Avatar = ({ src, name, className = "", textClass = "text-base" }) => {
  const initial = (name || "?").trim().charAt(0).toUpperCase() || "?";
  if (src) {
    return <img src={mediaUrl(src)} alt={name || ""} className={`object-cover ${className}`} />;
  }
  return (
    <span
      role="img"
      aria-label={name || "artist"}
      className={`flex items-center justify-center bg-zinc-800 text-[#FFD60A] font-display font-bold select-none ${textClass} ${className}`}
    >
      {initial}
    </span>
  );
};
